module.exports = __webpack_public_path__ + "img/hp-h2.b70c0817.svg";